<i18n>
{
  "en": {
    "recipients": "default addresses",
    "notSet": "not set",
    "notification": {
      "testSave": {
        "title": "Save and Test",
        "message": "Do you really wish to save notification and send test message?"
      }
    }
  },
  "ru": {
    "recipients": "общий адрес получателя уведомлений",
    "notSet": "не задан",
    "notification": {
      "testSave": {
        "title": "Сохранить и проверить",
        "message": "Вы действительно хотите сохранить уведомление и отправить тестовое сообщение?"
      }
    }
  }
}
</i18n>

<template>
  <div class="content-block dx-card responsive-paddings">
    <dx-form
      :key="id"
      :ref="formRefName"
      id="form"
      label-location="left"
      labelMode="outside"
      :form-data="dataNotif"
      :col-count="1"
      :read-only="loading || !isEditableForm"
      validation-group="notificationValidation"
      @field-data-changed="formFieldDataChanged"
    >
      <dx-group-item
        cssClass="commonproperties"
        :caption="$t('notification.groups.commonproperties')"
        :colCountByScreen="colCountByScreen"
      >
        <dx-simple-item data-field="notification.id"
          :visible ="false"
          :editor-options="editorSettings.id"
        >
          <dx-label :text="$t('notification.id')" :show-colon="false" />
        </dx-simple-item>

        <dx-simple-item data-field="notification.notificationType.code"
          editor-type="dxLookup"
          :editor-options="editorsOptions.notificationType"
        >
          <dx-label :text="$t('notification.notiftypename')" :show-colon="false" />
        </dx-simple-item>

        <dx-simple-item data-field="notification.name">
          <dx-label :text="$t('notification.name')" :show-colon="false" />
          <dx-required-rule :message="$t('general.mandatory')" />
        </dx-simple-item>
      </dx-group-item>

      <dx-group-item>
        <dx-simple-item data-field="notification.active"
          editor-type="dxSwitch"
          :editor-options="editorSettings.active"
        >
          <dx-label :text="$t('notification.switch')" :show-colon="false" />
        </dx-simple-item>
      </dx-group-item>

      <dx-group-item>
        <dx-simple-item
          data-field="notification.description"
          editor-type="dxTextArea"
          :editor-options="editorSettings.description"
        >
          <dx-label :text="$t('notification.description')" :show-colon="false" />
        </dx-simple-item>
      </dx-group-item>

      <dx-group-item>
        <dx-simple-item data-field="notification.subject">
          <dx-label :text="$t('notification.subject')" :show-colon="false" />
          <dx-required-rule :message="$t('general.mandatory')" />
        </dx-simple-item>
      </dx-group-item>

      <dx-group-item>
        <dx-simple-item data-field="notification.body"
          editor-type="dxHtmlEditor"
          :editor-options="htmlEditorOptions"
        >
          <dx-label :text="$t('notification.body')" :show-colon="false" />
          <dx-required-rule :message="$t('general.mandatory')" />
        </dx-simple-item>
      </dx-group-item>

      <dx-group-item>
        <dx-simple-item data-field="notification.attachmentTag"
          editor-type="dxTagBox"
          :editor-options="attachmentOptions"
        >
          <dx-label :text="$t('notification.attachment')" :show-colon="false" />
          <dx-required-rule :message="$t('general.mandatory')" />
        </dx-simple-item>
      </dx-group-item>

      <dx-group-item
        :caption="$t('notification.groups.specialproperties')"
      >
        <dx-simple-item
          data-field="notification.locations"
          editor-type="dxTagBox"
          :editor-options="editorsOptions.locations"
        >
          <dx-label :text="$t('notification.location')" :show-colon="false" />
        </dx-simple-item>

        <dx-simple-item data-field="notification.dim01List"
          editor-type="dxTagBox"
          :editor-options="editorsOptions.dim01List"
        >
          <dx-label :text="$t('notification.printertypes')" :show-colon="false" />
        </dx-simple-item>
      </dx-group-item>

      <dx-group-item :caption="$t('notification.groups.recipients')">
        <dx-simple-item data-field="notification.subscribers"
          editor-type="dxTagBox"
          :visible="true"
          :isRequired="dataNotif.notification.active"
          :editor-options="editorsOptions.subscribers"
        >
          <dx-label :text="$t('notification.subscribers')" :show-colon="false" />
        </dx-simple-item>
      </dx-group-item>

      <dx-group-item
        :caption="$t('notification.schedule.title')"
        :alignItemLabels="false"
        :colCountByScreen="colCountByScreenSchedule"
      >
        <dx-simple-item data-field="scheduleDetail.id"
          :colSpan="1"
          editor-type="dxSelectBox"
          :editor-options="editorsOptions.scheduleDetail"
        >
          <dx-label :text="$t('notification.schedule.detail.send')" :show-colon="false" />
        </dx-simple-item>

        <dx-group-item
          :alignItemLabels="false"
          :colCountByScreen="colCountByScreenScheduleAction"
          :colSpan="2"
        >
          <dx-simple-item data-field="scheduleDetail.monthly.dayofmonth"
            :visible="flVisibleScheduleDetailMonthly"
            editor-type="dxNumberBox"
            :editor-options="editorsOptions.dayofmonth"
          >
            <dx-label :text="$t('notification.schedule.detail.monthly.dayofmonth')" :show-colon="false" />
          </dx-simple-item>

          <dx-simple-item data-field="scheduleDetail.monthly.lastdayofmonth"
            :visible="flVisibleScheduleDetailMonthly"
            editor-type="dxCheckBox"
          >
            <dx-label :text="$t('notification.schedule.detail.monthly.lastdayofmonth')" :show-colon="false" />
          </dx-simple-item>

          <dx-group-item :alignItemLabels="false" :colSpan="1" :visible="flVisibleScheduleDetailWeekly">
            <!-- eslint-disable vue/no-unused-vars -->
            <div slot-scope="_">
              <DxButtonGroup
                :items="weekDays"
                key-expr="id"
                selection-mode="multiple"
                :selectedItemKeys="weekDaysKey"
                :focus-state-enabled="false"
                @selection-changed="selectWeekDays"
              />
            </div>
            <!-- eslint-enable -->
          </dx-group-item>
          
          <dx-simple-item
            data-field="scheduleDetail.time"
            editor-type="dxDateBox"
            :editor-options="editorSettings.time"
            :colSpan="1"
            cssClass="time-box"
            :visible="flVisibleScheduleDetailTime"
          >
            <dx-label :text="$t('notification.schedule.detail.time')" :show-colon="false" />
          </dx-simple-item>
        </dx-group-item>
      </dx-group-item>
    </dx-form>

    <div class="app-form-buttons">
      <!-- сделать tooltip для aims2-button, когда disabled=true -->
      <div :title="!isEditableForm ? $t('notification.insufficientAccessActions') : ''">
        <aims2-button
          icon="save"
          type="default"
          :text="$t('general.save')"
          :disabled="loading || saving || !isEditableForm"
          :busy="saving"
          @click="onSave"
        />
      </div>
      <div :title="!isEditableForm ? $t('notification.insufficientAccessActions') : ''">
        <aims2-button
          icon="trash"
          type="danger"
          :text="$t('general.delete')"
          :disabled="loading || !dataNotif.notification || !dataNotif.notification.id || saving || !isEditableForm"
          :busy="deleting"
          @click="onDelete"
        />
      </div>
      <div :title="!isEditableForm ? $t('notification.insufficientAccessActions') : ''">
        <aims2-button
          :text="$t('general.test')"
          :busy="testing"
          :disabled="testDisabled || saving || !isEditableForm"
          @click="onTest"
        />
      </div>
    </div>
  </div>
</template>

<script>
import baseView from '../../base.vue';
import appInfo from '../../../app-info';

import { mapActions, mapGetters } from 'vuex'
import { mapCacheActions } from 'vuex-cache';

import {
  DxForm,
  DxGroupItem,
  DxSimpleItem,
  DxLabel,
  DxRequiredRule,
  DxValidationRule
} from 'devextreme-vue/form';
import { DxSwitch } from 'devextreme-vue/switch';
import { DxButtonGroup } from 'devextreme-vue/button-group';

import { notifier } from '@/shared/lib/notifier/index';

import aims2Button from '@/components/active-button.vue';
import { scheduleTypeDataSourceConfig } from '../constants';
import { getSchedule, getScheduleDeatail} from '../schedule';

import { testNotification } from '@/services/api';

import { DataBacked } from "@/mixins/dataBackedMixin";
import { notificationMixin } from "@/mixins/notificationMixin";

export default {
  name: 'NotificationCounters',
  props: {
    id : [ Number, String ],
  },
  extends: baseView,
  mixins: [ DataBacked, notificationMixin ],
  components: {
    DxForm, DxGroupItem, DxSimpleItem, DxLabel, aims2Button, DxButtonGroup, DxRequiredRule,
    // eslint-disable-next-line
    DxSwitch, DxValidationRule
  },
  data() {
    const specificationsCSV = {
      "counters": [
        'ip;',
        'serialNumber;',
        "inventoryNumber;",
        'modelCode;',
        'hostname;',
        'snmpLocation;',
        'status;',
        'location;',
        'printedPageCount;',
        'printedBwPageCount;',
        'printedColorPageCount;',
        'printedPageA3Count;',
        'printedPageA3BwCount;',
        'printedPageA3ColorCount;',
        'printedPageA4Count;',
        'printedPageA4BwCount;',
        'printedPageA4ColorCount;',
        'copyPageCount;',
        'scanPageCount;'
      ]
    };
    return {
      formRefName: 'formNotification',
      notificationTypes: null,
      printerTypes: null,
      dataEditorInstance: null,
      htmlEditorOptions: {
        height: 200,
        toolbar: {
          items: [
            "undo", "redo", "separator", "bold", "italic", "strike", "underline", "separator", "alignLeft",
            "alignCenter", "alignRight", "alignJustify", "separator", "color", "background", "separator",
          ]
        },
        onInitialized: this.handleEditorInstance,
      },
      dataAttachmentInstance: null,
      tagAttachment: null,
      attachmentOptions: {
        dataSource: specificationsCSV.counters,
        showSelectionControls: true,
        hideSelectedItems: true,
        showClearButton: true,
        searchEnabled: true,
        searchMode: 'contains',
        onInitialized: this.handleAttachmentInstance
      },
      speciCSV: specificationsCSV
    };
  },
  computed : {
    ...mapGetters([
      'getNotification',
      'getCreatedNotification',
      'getLocations',
      'getSubscribers',
    ]),
    editorsOptions() {
      return {
        notificationType: {
          dataSource: this.notificationTypes,
          key: 'code',
          displayExpr: 'name',
          valueExpr: 'code',
          searchEnabled: true,
          searchExpr: ['name'],
          searchMode: 'contains',
          disabled: this.dataNotif.notification.id,
          showCancelButton: false,
          dropDownOptions: { hideOnOutsideClick: true, showTitle: false }
        },
        locations: {
          dataSource: this.getLocations,
          key: 'id',
          displayExpr: 'name',
          searchEnabled: true,
          searchExpr: ['name'],
          searchMode: 'contains',
          showSelectionControls: true
        },
        dim01List: {
          dataSource: this.printerTypes,
          key: 'id',
          displayExpr: 'name',
          searchEnabled: true,
          searchExpr: ['name'],
          searchMode: 'contains'
        },
        subscribers: {
          dataSource: this.getSubscribers,
          displayExpr: 'email',
          searchEnabled: true,
          searchExpr: ['email'],
          searchMode: 'contains',
          noDataText: this.$t('notification.nodatasubscribers'),
          showSelectionControls: true
        },
        scheduleDetail: {
          dataSource: scheduleTypeDataSourceConfig.store.data.filter(type => type.id !== 'IMMEDIATELY'),
          displayExpr: 'text',
          valueExpr: 'id'
        },
        dayofmonth: {
          format: '#0',
          max: 28,
          min: 1,
          showSpinButtons: true,
          disabled: this.flVisibleScheduleDetailMonthlyDayOfMonth
        }
      }
    }
  },
  methods: {
    ...mapCacheActions([
      'getNotificationTypes',
      'getPrinterTypes'
    ]),
    ...mapActions([
      'fetchNotification',
      'setCreatedNotification',
      'saveNotification',
      'updateNotification',
    ]),
    handleEditorInstance(e) {
      this.dataEditorInstance = e.component;
    },
    handleAttachmentInstance(e) {
      this.dataAttachmentInstance = e.component;
    },
    async loadNotification(id) {
      this.loading = true;
      try {
        this.notificationTypes = await this.getNotificationTypes();
        this.printerTypes = await this.getPrinterTypes();
        if (id) {
          await this.fetchNotification(id);
          const notification = this.getNotification;
          const scheduleDetail = await getScheduleDeatail(notification.schedule);
          this.dataNotif.notification = notification;
          this.dataNotif.scheduleDetail = scheduleDetail;

          if (this.dataNotif.notification.attachment) {
            this.dataNotif.notification.attachmentTag = this.dataNotif.notification.attachment.split(';').map(el => {
              if (el)
                return el + ';';
            });
            this.dataNotif.notification.attachmentTag.pop();
          }

          if (notification.isScheduled) {
            if (scheduleDetail.id == "WEEKLY") {
              this.flVisibleScheduleDetailWeekly = true;
              this.weekDaysKey = scheduleDetail.weeks.days;
            } else if (scheduleDetail.id == "MONTHLY") {
              this.flVisibleScheduleDetailMonthly = true;
              if(scheduleDetail.monthly.lastdayofmonth == true) {
                this.flVisibleScheduleDetailMonthlyDayOfMonth = true;
              } else {
                this.flVisibleScheduleDetailMonthlyDayOfMonth = false;
              }
            }
          } else {
            const defaultDate = new Date();
            defaultDate.setHours(10);
            defaultDate.setMinutes(0);

            if (scheduleDetail && scheduleDetail.time) {
              this.dataNotif.scheduleDetail = {
                id: 'IMMEDIATELY',
                time: scheduleDetail.time
              };
            } else {
              this.dataNotif.scheduleDetail = {
                id: 'IMMEDIATELY',
                time: defaultDate
              };
            }
          }

          //locations
          if (this.dataNotif.notification.locations != undefined && this.dataNotif.notification.locations != null ) {
            for (let i = 0; i < this.dataNotif.notification.locations.length; i++) {
              let y = this.getLocations.findIndex(item => item.id == this.dataNotif.notification.locations[i].id);
              if ( y != -1) {
                this.getLocations.splice(y, 1);
                this.getLocations.push(this.dataNotif.notification.locations[i]);
              }
            }
          }

          //subscribers
          if (this.dataNotif.notification.subscribers != undefined && this.dataNotif.notification.subscribers != null ) {
            for (let i = 0; i < this.dataNotif.notification.subscribers.length; i++) {
              let y = this.getSubscribers.findIndex(item => item.id == this.dataNotif.notification.subscribers[i].id);
              if ( y != -1) {
                this.getSubscribers.splice(y, 1);
                this.getSubscribers.push(this.dataNotif.notification.subscribers[i]);
              }
            }
          }

          //printer type
          if (this.dataNotif.notification.dim01List != undefined && this.dataNotif.notification.dim01List != null ) {
            for (let i = 0; i < this.dataNotif.notification.dim01List.length; i++) {
              let y = this.printerTypes.findIndex(item => item.id == this.dataNotif.notification.dim01List[i].id);
              if ( y != -1) {
                this.printerTypes.splice(y, 1);
                this.printerTypes.push(this.dataNotif.notification.dim01List[i]);
              }
            }
          }
        } else {
          const defaultDate = new Date();
          defaultDate.setHours(10);
          defaultDate.setMinutes(0);

          const data = {};
          data.scheduleDetail = {
            id: 'DAILY',
            time: defaultDate
          }
          
          data.notification = { 
            active: true,
            isScheduled: true,
            notificationType: {
              code: 'COUNTERS'
            },
            subscribers: [],
            dim01List: [],
          };

          this.dataNotif = {...data, ...this.getCreatedNotification};
          this.normalizeScheduledOnlyDetail();

          this.dataNotif.notification.attachmentTag = this.speciCSV.counters;
          this.setCreatedNotification(this.dataNotif);
        }

        this.$store.commit('setBreadcrumb', [{
          link: '/notifications',
          title: this.$t('notifications.title')
        }, {
          link: id ? `/notification/${id}` : '/notification',
          title: id ? this.getNotification.name : this.$t('notification.create.newNotification')
        }]);
      } catch(err) {
        this.onDataError(err);
      } finally {
        this.loading = false; 
      }
    },
    async formFieldDataChanged(e) {
      switch (e.dataField) {
        case 'notification.notificationType.code':
          if (!this.id)
            this.setCreatedNotification(this.dataNotif);
          this.$emit('changeNotification', e.value);

          this.normalizeScheduledOnlyDetail();

          if (!this.dataNotif.notification.id) {
            this.dataAttachmentInstance.option('dataSource', this.speciCSV.counters);
            this.dataAttachmentInstance.option('value', this.speciCSV.counters);
          }

          if (!this.dataNotif.notification.attachment) {
            this.dataNotif.notification.attachmentTag = this.attachmentOptions.dataSource;
          }
          break;
        case 'scheduleDetail.id':
            this.flVisibleScheduleDetailWeekly = false;
            this.flVisibleScheduleDetailMonthly = false;
            this.flVisibleScheduleDetailTime = true;
            this.dataNotif.notification.isScheduled = true;
          switch (e.value) {
            case 'WEEKLY':
              this.flVisibleScheduleDetailWeekly = true;
              if (!this.dataNotif.notification.id)
                this.dataNotif.scheduleDetail.weeks= {
                  days: ["MON"]
                };
              break;
            case 'MONTHLY':
              this.flVisibleScheduleDetailMonthly = true;
              break;
            case 'IMMEDIATELY':
              this.flVisibleScheduleDetailTime = false;
              this.dataNotif.notification.isScheduled = false;
              break;
            default:
              break;  
          }
          break;
        case 'scheduleDetail.monthly.lastdayofmonth':
          this.flVisibleScheduleDetailMonthlyDayOfMonth = e.value;
          break;
        default:
          break;
      }
    },
    async save(test) {
      const error = await this.validateValues();
      if (!error)
        return;

      this.dataNotif.notification.schedule = await getSchedule(this.dataNotif.scheduleDetail, this.dataNotif.scheduleDetail.time);
      this.dataNotif.notification.notificationType = this.notificationTypes.find(type => this.dataNotif.notification.notificationType.code === type.code);

      try {
        this.saving = true;
        if (this.dataNotif.notification.attachmentTag && ['COUNTERS', 'REPORT'].includes(this.dataNotif.notification.notificationType.code)) {
          this.tagAttachment = this.dataNotif.notification.attachmentTag.toString().replaceAll(',', '');
          this.dataNotif.notification.attachment = this.tagAttachment;
          delete this.dataNotif.notification.attachmentTag;
        }

        if (this.dataNotif.notification.id) {
          await this.updateNotification({id: this.dataNotif.notification.id, data: this.dataNotif.notification});
          notifier.showSuccess(this.$t('general.updateSuccess'));
        } else {
          await this.saveNotification(this.dataNotif.notification);
          notifier.showSuccess(this.$t('general.createSuccess'));
          this.$router.replace({
            name: "notification",
            params: { id: this.getNotification.id, type: this.getNotification.notificationType.code }
          });
        }

        if (test) {
          await testNotification(this.getNotification.id);
          notifier.showSuccess(this.$t('notification.testNotification'));
        }

        if (this.dataNotif.notification.attachment) {
          this.dataNotif.notification.attachmentTag = this.tagAttachment.split(';').map(el => {
            if (el)
              return el + ';';
          });
          this.dataNotif.notification.attachmentTag.pop();
          await this.dataAttachmentInstance.option('value', this.dataNotif.notification.attachmentTag);
        }
      } catch(err) {
        this.onDataError(err);
      } finally {
        this.saving = false;
      }
    },
  },
  async created() {
    document.title = `${appInfo.title} - ${this.$t('notification.title')}`;
    await this.loadNotification(this.id || this.$route.params.id);
  },
  watch: {
    id(id) {
      this.loadNotification(id || this.$route.params.id);
    },
  }
}
</script>

<style lang="scss">
.commonproperties .dx-form-group-content {
  padding-bottom: 0 !important;
}

.dx-button-mode-contained.dx-button-default .dx-icon-add {
  color: #fff !important;
}

.recipients {
  display: flex;

  .recipient-info {
    display: flex;
  }
}

.system-label {
  user-select: none;
}

.time-box {
  margin-left: 8px;

  label span {
    width: auto !important;
  }
}

.dx-item {
  margin-bottom: 10px;
}

.dx-popup-title.dx-toolbar .dx-toolbar-before {
  width: 100%;
}
</style>